<template>
  <div class="page">
    <div class="div-header-select">
      <div class="div-center">
        <div style="width:10vw">操作名称：</div>
          <el-input clearable maxlength="15"  @clear="query()"  v-model="queryName"></el-input>
      </div>
      <el-button size="medium" @click="getDataList(queryName)" style="margin-left: 15px">查询</el-button>
    </div>

    <main>
      <el-table 
           height="calc(100vh - 200px)"  :data="listData" @cell-mouse-enter="cellMouseEnter" style="width: 100%">
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="apiName" label="操作名称" align="center">
        </el-table-column>
        <el-table-column prop="applicantName" label="申请人" align="center">
        </el-table-column>
        <el-table-column prop="reviewName" label="审核人" align="center">
        </el-table-column>
        <el-table-column prop="status" width="120vw" label="审核状态" align="center">
          <template slot-scope="scope" >
            <el-popover trigger="click" placement="top">
              <p v-if="scope.row.comment ==''">{{ "无信息" }}</p>
              <p>{{ scope.row.comment }}</p>
              <div slot="reference"  class="name-wrapper">
                <el-button   size="mini"  style="padding: 5px 5px; width:80px;"  type="success" round v-if="scope.row.status=='通过'">{{ scope.row.status }}<i class="el-icon-info el-icon--right"></i></el-button >
                <el-button size="mini"  style="padding: 5px 5px; width:80px;" type="danger" round v-else-if="scope.row.status=='未通过'" >{{ scope.row.status }}<i class="el-icon-info el-icon--right"></i></el-button>
                <el-button size="mini"  style="padding: 5px 5px; width:80px;"  type="primary" round v-else-if="scope.row.status=='待审核'" >{{ scope.row.status }}<i class="el-icon-info el-icon--right"></i></el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="执行状态"  width="140vw" align="center">
          <template slot-scope="scope">
            <el-popover trigger="click" opper-class="el-popover"  placement="top">
              <p v-if="scope.row.doComment ==''">{{ "无信息" }}</p>
              <p>{{ scope.row.doComment }}</p>
              <div slot="reference" class="name-wrapper">
                <el-button   size="mini"  style="padding: 5px 5px; width:80px;"  type="success" round v-if="scope.row.doStatus=='执行成功'">{{ scope.row.doStatus }}<i class="el-icon-info el-icon--right"></i></el-button >
                <el-button size="mini"  style="padding: 5px 5px; width:80px;" type="danger" round v-else-if="scope.row.doStatus=='执行失败'" >{{ scope.row.doStatus }}<i class="el-icon-info el-icon--right"></i></el-button>
                <el-button size="mini"  style="padding: 5px 5px; width:80px;"  type="primary" round v-else-if="scope.row.doStatus=='待执行'" >{{ scope.row.doStatus }}<i class="el-icon-info el-icon--right"></i></el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="apiParams" label="申请内容" align="center">
        </el-table-column>
        <el-table-column prop="createdTime" label="提交时间" align="center">
        </el-table-column>
        <el-table-column prop="reviewTime" label="审核时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope" v-if='scope.row.status=="待审核"'>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="reviewYes(scope.row)" 
            >通过</el-button>
            <el-button
              type="danger"
              plain
              size="mini"
              @click="reviewNo(scope.row)"
            >不通过</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>
  </div> 
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import FileUpload from "./FileUpload";
import { Decimal } from "decimal.js";

import mixins from "../../minix";
let _vue;

export default {
  mixins: [mixins],
  name: "home",
  components: { FileUpload },

  data() {
    return {
      pageIdx: 0,
      itemTotal: 0,
      dialogVisible: false,
      listData: [],
      state: "",

      houseNameRegex: "",
      areaID: "",
      areasMap: new Map(),
      reviewStatus:"",
        queryName:"",
      dialogUploadVisible: false,
      dialogUploadFile: "",

      dialogBillsVisible: false,

      pricings: []
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.query(0);

    _vue = this;
  },

  watch: {
    state() {
      this.initQuery();
    },
  },

  methods: {
     cellMouseEnter(row, column, cell,event) {   //控制展开行
      // let NoIndex = column.type.indexOf("expand"); 
    },
    handleCurrentChange(val) {
      // eslint-disable-next-line no-console
      this.pageIdx = val;
      this.query(val - 1);
    },

    handleSizeChange(val) {
      // eslint-disable-next-line no-console
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    // 审核通过
    reviewYes(item) {
      let _vue = this;
      _vue.reviewStatus = "通过"
      this.review(item)
    },

    // 审核不通过
    reviewNo(item) {
      let _vue = this;
      _vue.reviewStatus = "未通过"
      
      this.review(item)
    },
    review (item){
      this.$prompt(
              `请输入审核说明`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
              }
            )
              .then(({ value }) => {
                axios({
                  method: "post",
                  url: "reviewrecords/review",
                  data: {
                    recordID: item.id,
                    comment: value,
                    status: _vue.reviewStatus,
                  }
                })
                  .then(value => {
                    if (value.data.code === 0) {
                      this.$message.success(value.data.message);
                    } else {
                      this.$message.error(value.data.message);
                    }
                  })
                  .finally(() => {
                    _vue.query(_vue.pageIdx - 1);
                  });
              })
              .catch(() => {});
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(0);
    },
    //条件搜索
    getDataList(res){
      this.queryName=res
      this.query()
    },
    //列表查询
    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        pageSize: this.pageSize,
        pageIdx: pageIdx,
        orgID:this.$route.query.orgID ,
        name: this.queryName
      };
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "reviewrecords",
        data: data
      })
        .then(value => {
           this.listData = [];
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
              item.createdTime = Utils.long2second(item.createdTime * 1000);
              item.reviewTime = Utils.long2second(item.reviewTime * 1000);
              if(item.status=="待审核"){
                item.reviewTime=""
              }
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-input-group__prepend {
  width: 140px !important;
}
.el-input-group--prepend {
  margin-bottom: 10px;
}
.el-popover{
    background-color: #242527!important;
    color: #ffffff!important; 
    padding: 0px!important;
}
.el-popper[x-placement^=top]
.popper__arrow::after {
    bottom: 1px;
    margin-left: -6px;
    border-top-color: #242527;
    border-bottom-width: 0;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.header-title {
  width: 150px;
}
</style>
